import { HTTP_TOKEN } from "./http";

export const listUser = () => {
  return HTTP_TOKEN.get("account/manager/user").then((result) => {
    return result.data;
  });
};

export const createUser = (data) => {
  return HTTP_TOKEN.post("account/manager/user", data).then((result) => {
    return result.data;
  });
};

export const updateUser = (user_id, data) => {
  return HTTP_TOKEN.put(`account/manager/user/${user_id}`, data).then(
    (result) => {
      return result.data;
    }
  );
};

export const deleteUser = (user_id) => {
  return HTTP_TOKEN.delete(`account/manager/user/${user_id}`).then((result) => {
    return result.data;
  });
};
